import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign"
import useToggle from "../../../../hooks/toggle"
import { selecteddocumentesign } from "../ReviewDocs"
import { useReactToPrint } from "react-to-print"
import { useParams } from "react-router-dom"
import { getexternaldocuments, getSavedOfferDetails, sendWireFraud } from "../../../../api/transaction"
import { useSelector } from "react-redux"
import { CSpinner } from "@coreui/react"
const ReqWireFraud = ()=>{
    const params: { id: any, user: string } = useParams()
    const { id, user } = params
const [wirefrad,setWireFraud] = useState({
    offer_id :id,
    purchase_agreement_date :"",
    property_address :"",
    buyer1_signature :"",
    buyer1_signature_date :"",
    buyer2_signature :"",
    buyer2_signature_date :"",
    buyer3_signature :"",
    buyer3_signature_date :"",
    seller1_signature :"",
    seller1_signature_date :"",
    seller2_signature :"",
    seller2_signature_date :"",
    seller3_signature :"",
    seller3_signature_date :""
})
const [loader,setloading] = useState(false)
const componentRef = useRef();
const [canvasmodal, setCanvasModal] = useToggle(false);
const [htmlContent, setHtmlContent] = useState("");
const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid: "",
    document_name: "",
    image_base64: "",
    sign_role: 1
})
const [offerdetails, setOfferDetails] = useState({});
const printf = () => {
    handlePrint()
};
// @ts-ignore
const val = useSelector((state) => state?.new?.signset)
const handlePrint = useReactToPrint({
    content: () => componentRef.current,
});

useEffect(()=>{
  if(val){
      if(user == "seller"){
        setWireFraud({ ...wirefrad, seller1_signature: val })
      }
      if(user == "client"){
        setWireFraud({ ...wirefrad, buyer1_signature: val })
      }
  }
  },[val])

const send = async () => {
    setloading(true)
    if (user === "seller") {
      // const run = async () => { return setWireFraud({ ...wirefrad, seller1_signature: val }) }
      // await run()
      if (wirefrad?.seller1_signature) {
        const res = await sendWireFraud(wirefrad)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }
    } else if (user === "client") {
      // const run = async () => { return setWireFraud({ ...wirefrad, buyer1_signature: val }) }
      // await run()
      if (wirefrad?.buyer1_signature) {
        const res = await sendWireFraud(wirefrad)
        if(res?.status == "success"){
          alert("Submitted Successfully")
      }
      else{
          alert("Something went wrong")
      }
      }
    }
    setloading(false)
  }

  useEffect(() => {
    (async function () {
        let offerdetails = await getSavedOfferDetails(id)
        setOfferDetails(offerdetails[0])
        const res =await getexternaldocuments(id,"wirefraud") 
        setWireFraud({...wirefrad,
          purchase_agreement_date :res?.data?.purchase_agreement_date,
          property_address :res?.data?.property_address,
          buyer1_signature :res?.data?.buyer1_signature,
          buyer1_signature_date :res?.data?.buyer1_signature_date,
          buyer2_signature :res?.data?.buyer2_signature ,
          buyer2_signature_date :res?.data?.buyer2_signature_date,
          buyer3_signature :res?.data?.buyer3_signature,
          buyer3_signature_date :res?.data?.buyer3_signature_date,
          seller1_signature :res?.data?.seller1_signature,
          seller1_signature_date :res?.data?.seller1_signature_date,
          seller2_signature :res?.data?.seller2_signature,
          seller2_signature_date :res?.data?.seller2_signature_date,
          seller3_signature :res?.data?.seller3_signature,
          seller3_signature_date :res?.data?.seller3_signature_date
        })
    })()

}, [])

    return (
        <>
        <section>
  <table
    style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 20 }}
  >
    <tbody>
      <tr>
        <td>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ width: "90%" }}>
                  <img
                    style={{ width: 250 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                  />
                </td>
                <td>
                  <img
                    style={{ width: 40, marginRight: 15 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                    alt=""
                  />
                  <img
                    style={{ width: 50 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                    alt=""
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <span style={{ fontSize: 20, fontWeight: 700 }}>
            Wire Fraud Notice Addendum
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          This addendum is in addition to and becomes part of the Purchase
          Agreement dated{" "}
          <input
            type="text" // @ts-ignore  
            value={offerdetails?.offerDate}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "30%"
            }}
          />
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          on the property known as{" "}
          <input
            type="text" // @ts-ignore  
            value={offerdetails?.propertyAddress}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "75%"
            }}
          />
        </td>
      </tr>
      <tr>
        <td style={{ fontWeight: 700, padding: "10px 0px" }}>
          Notice to Buyer and Seller Regarding Wire Fraud and Suspicious
          Communications:
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          Please be aware that the Escrow Company under the attached Agreement
          may require a wire transfer of funds at Closing. Buyer and Seller
          should take care to provide wire transfer information only to a proper
          agent of the Escrow Company. Funds should only be wired to the Escrow
          Company using account information provided by verified agents of the
          Escrow Company.
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          Recently, criminals have been found attempting to impersonate escrow
          companies and real estate agents in wire fraud schemes. Unauthorized
          individuals have been caught providing fraudulent wire transfer
          information to parties in real estate transactions. This could include
          a criminal contacting Buyer or Seller, directly or indirectly, in an
          attempt to steal funds that rightfully belong to the parties.{" "}
          <span style={{ fontWeight: 700 }}>
            These sophisticated criminals may try to hack into your email
            account or the email of other persons involved in your transaction
            and direct you to send a wire to the hacker’s account. THEY CAN EVEN
            SEND EMAILS THAT APPEAR TO BE FROM YOUR AGENT, YOUR CLOSER OR
            ANOTHER TRUSTED SOURCE!{" "}
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ fontWeight: 700, padding: "10px 0px" }}>
          MILFORD REAL ESTATE WILL NEVER ASK YOU TO WIRE MONEY VIA EMAIL, EVER!
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          In the event any party believes an unauthorized request has been made
          for bank account information or funds, the Escrow Company should be
          contacted immediately. The request should be verified immediately in
          person or by telephone using a telephone number that is known to be
          valid. Parties should be especially skeptical of last minute changes
          or requests coming from unknown representatives.{" "}
          <span style={{ fontWeight: 700 }}>
            DO NOT USE A PHONE NUMBER OR OTHER CONTACT INFORMATION FROM AN
            EMAIL. Use a business number from another source (such as the
            closing company’s website) to make sure you are actually talking to
            your closer and not someone intent on stealing your money.{" "}
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          In the event funds are transferred to a fraudulent account, there may
          be no way to recover these funds from the criminals involved. For this
          reason, it is extremely important that the Buyer and Seller are
          vigilant and only provide wire transfer information to proper
          representatives of the Escrow Company.
        </td>
      </tr>
      <tr>
        <td style={{ fontWeight: 700, color: "#3b0083", padding: "10px 0px" }}>
          PLEASE CONTACT THE ESCROW COMPANY DIRECTLY IF YOU HAVE ANY QUESTIONS.
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <table style={{ width: "100%", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <td>
                {(!val && !wirefrad?.buyer1_signature) && <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid black",
                      maxWidth: '250px',
                      width: '100%'
                    }}
                  />}
                <img src={user === "client" ? (val || wirefrad?.buyer1_signature) : wirefrad?.buyer1_signature} alt="" style={{width: '100%', maxWidth: '230px'}}/>
                  <br />
                  Buyer
                </td>
                <td>
                  <input type="date" 
                         value={wirefrad?.buyer1_signature_date ? wirefrad?.buyer1_signature_date :(user === "client" && val || wirefrad?.buyer1_signature) ?  new Date().toISOString().split('T')[0] : ""}
                         onChange={(e)=>setWireFraud({...wirefrad,buyer1_signature_date:e.target.value})}
                  />
                  <br />
                  Date
                </td>
                <td>
                {(!val || !wirefrad?.seller1_signature) && <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid black",
                      maxWidth: '250px',
                      width: '100%'
                    }}
                  />}
                <img src={user === "seller" ? (val || wirefrad?.seller1_signature) : wirefrad?.seller1_signature} alt=""  style={{width: '100%', maxWidth: '230px'}}/>
                  <br />
                  Seller
                </td>
                <td>
                  <input type="date"
                  value={wirefrad?.seller1_signature_date ? wirefrad?.seller1_signature_date :(user === "seller" && val || wirefrad?.buyer1_signature) ?  new Date().toISOString().split('T')[0] : ""}
                  onChange={(e)=>setWireFraud({...wirefrad,seller1_signature_date:e.target.value})}
                  />
                  <br />
                  Date
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <table style={{ width: "100%", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid black",
                        maxWidth: '250px',
                        width: '100%'
                    }}
                  />
                  <br />
                  Buyer
                </td>
                <td>
                  <input type="date" />
                  <br />
                  Date
                </td>
                <td>
                  <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid black",
                      width: 250
                    }}
                  />
                  <br />
                  Seller
                </td>
                <td>
                  <input type="date" />
                  <br />
                  Date
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "15px 0px" }}>
          <table style={{ width: "100%" , tableLayout: "fixed"}}>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid black",
                      width: 250
                    }}
                  />
                  <br />
                  Agent
                </td>
                <td>
                  <input type="date" />
                  <br />
                  Date
                </td>
                <td>
                  <input
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid black",
                      width: 250
                    }}
                  />
                  <br />
                  Agent
                </td>
                <td>
                  <input type="date" />
                  <br />
                  Date
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<React.Fragment>
                <div className="d-flex align-items-center justify-content-end mb-2 mr-2">
                    <button onClick={send} className="btn primaryColorBtn">Submit
                    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
                    </button>
                    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
                    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button>
                </div>
            </React.Fragment>

            <Esign
                canvasmodal={canvasmodal}
                setCanvasModal={setCanvasModal}
                htmlContent={htmlContent}
                setHtmlContent={setHtmlContent}
                selecteddocumentesign={selecteddocumentesign}
                setselectedDocumentEsign={setselectedDocumentEsign}
                type={"seller"}
            ></Esign>
        </>
    ) 
}
export default ReqWireFraud